const AuraToolbarButton = ({
  children,
  onClick,
  selected = false,
  disabled = false,
  dataTestId,
  title,
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    title={title}
    data-testid={dataTestId}
    className="px-12 py-6 rounded-lg text-12 font-bold border border-solid"
    style={{
      background: selected ? "#eef0ff" : "#fff",
      color: disabled ? "#b6bcc8" : selected ? "#4f46e5" : "#475467",
      borderColor: selected ? "#c7cdfa" : "#e6e9ef",
      cursor: disabled ? "not-allowed" : "pointer",
    }}
  >
    {children}
  </button>
);

export default AuraToolbarButton;
